var __TEMP__ = require('./_isKeyable.js');var isKeyable = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = getMapData;
